import type { ElementType } from "react";
import { Switch } from "@/components/switch";
import { cn } from "@/lib/utils";

export function ToggleCard({
  icon: Icon,
  label,
  hint,
  checked,
  disabled = false,
  onChange,
}: {
  icon: ElementType;
  label: string;
  hint: string;
  checked: boolean;
  disabled?: boolean;
  onChange: (checked: boolean) => void;
}) {
  return (
    <div
      className={cn(
        "flex flex-1 items-center gap-3 rounded-lg border px-3 py-2.5 shadow-sm transition-[border-color,box-shadow,background-color]",
        disabled
          ? "border-dashed border-border/60 opacity-50"
          : checked
          ? "border-primary/40 bg-primary/5 ring-1 ring-primary/10"
          : "border-border/80 bg-background hover:border-primary/30"
      )}
      title={disabled ? "Velg en modellportefølje først" : undefined}
    >
      <span
        className={cn(
          "flex size-7 shrink-0 items-center justify-center rounded-md",
          checked
            ? "bg-primary/15 text-primary"
            : "bg-muted text-muted-foreground"
        )}
      >
        <Icon className="size-3.5" />
      </span>
      <div className="min-w-0 flex-1">
        <p className="text-xs font-semibold text-foreground">{label}</p>
        <p className="truncate text-[10px] text-muted-foreground">{hint}</p>
      </div>
      <Switch
        size="sm"
        checked={checked}
        disabled={disabled}
        onCheckedChange={onChange}
      />
    </div>
  );
}
